const updates = [
  { id: 1, date: '2026-07-31', title: '今日上线6部全新国产影片，91在线免费播放同步更新', tag: '片单更新' },
  { id: 2, date: '2026-07-30', title: '暑期档热门国产悬疑片《迷雾追踪》上线即破百万播放', tag: '热片速递' },
  { id: 3, date: '2026-07-29', title: '91精品视频在线播放画质升级，超清片源占比突破80%', tag: '体验优化' },
  { id: 4, date: '2026-07-28', title: '经典老片修复专区正式上线，百部经典高清重现', tag: '新功能' },
  { id: 5, date: '2026-07-27', title: '移动端观影体验全面优化，91在线观看免费更流畅', tag: '体验优化' },
  { id: 6, date: '2026-07-26', title: '91免费视频网站新增影片评分功能，观影选择更直观', tag: '新功能' },
  { id: 7, date: '2026-07-25', title: '平台片库总量突破5000部，91免费看视频选择更丰富', tag: '里程碑' },
  { id: 8, date: '2026-07-24', title: '91麻豆免费视频网站专题频道改版，分类浏览更便捷', tag: '界面更新' },
  { id: 9, date: '2026-07-23', title: '91福利在线视频夏季特别企划上线，多部独家影片首播', tag: '特别企划' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="section-scroll py-14 md:py-20 bg-gray-50/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-red-600 text-xs md:text-sm font-semibold tracking-widest uppercase mb-2">平台动态</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900">最新动态</h2>
          <p className="mt-2 text-gray-500 text-sm md:text-base max-w-lg mx-auto">
            91年国产影片视频的最新片单更新、功能改进与运营动态
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-red-200">
            {updates.map((item, index) => (
              <div
                key={item.id}
                className={`relative mb-6 md:mb-8 last:mb-0 ${
                  index === 0 ? 'animate-pulse' : ''
                }`}
              >
                <div className="absolute -left-[calc(2rem+5px)] md:-left-[calc(2.5rem+5px)] top-1 w-3 h-3 md:w-3.5 md:h-3.5 rounded-full bg-red-600 border-2 border-white ring-2 ring-red-200"></div>
                <div className="bg-white rounded-xl p-4 md:p-5 border border-gray-100 hover:border-red-200 transition-all duration-300">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="text-xs text-gray-400 flex items-center gap-1">
                      <i className="ri-calendar-line"></i>{item.date}
                    </span>
                    <span className={`px-2 py-0.5 rounded-md text-xs font-medium whitespace-nowrap ${
                      item.tag === '热片速递' || item.tag === '片单更新'
                        ? 'bg-red-50 text-red-600'
                        : item.tag === '新功能' || item.tag === '特别企划'
                        ? 'bg-amber-50 text-amber-600'
                        : item.tag === '里程碑'
                        ? 'bg-green-50 text-green-600'
                        : 'bg-gray-100 text-gray-600'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm md:text-base font-medium text-gray-800 leading-relaxed">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}